import { render } from "./LastPageLink.vue?vue&type=template&id=0896ebf0"
import script from "./LastPageLink.vue?vue&type=script&lang=js"
export * from "./LastPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script